import { createContext, useState } from 'react';

type SidebarContextType = {
  sidebarToggle: boolean;
  toggleSidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextType>({
  sidebarToggle: false,
  toggleSidebar: () => {},
});

interface Props {
  children: React.ReactNode;
}

export const SidebarProvider = ({ children }: Props) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };

  return (
    <SidebarContext.Provider value={{ sidebarToggle, toggleSidebar }}>
      {children}
    </SidebarContext.Provider>
  );
};
